































































import Vue from "vue";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";
import { store } from "@/store/store";
import { User } from "@/store/modules/User/interface";
import { ActionTypes } from "@/store/modules/Auth/actions-types";
import router from "@/router/router";

export interface ViewController {
  _id: string;
  name: string;
}

export default Vue.extend({
  name: "TopBar",
  components: {
    NavbarTitle
  },
  methods: {
    async disconnect_user(): Promise<void> {
      await store.dispatch(ActionTypes.DECONNEXION);
      router.push({ path: "/" });
    },
    change_view(item: ViewController): void {
      store.dispatch(ActionTypes.SET_VIEW, item._id);
    }
  },
  computed: {
    userAgence(): string {
      return store.getters.AGENCE_BY_ID[(store.getters.LOGGED_USER as User).agence].name.toUpperCase();
    },
    getView(): string | null {
      const view = store.getters.GET_VIEW;
      if (!view) return null;
      if (view === "ADMIN") return view;
      return store.getters.AGENCE_BY_ID[view].name.toUpperCase();
    },
    userName(): string {
      return (store.getters.LOGGED_USER as User).mail.toUpperCase();
    },
    different_view(): Array<ViewController> {
      return [{ _id: "ADMIN", name: "ADMIN" }].concat(
        store.getters.AGENCE_ALL_ID.map((agence_id) => {
          const agence = store.getters.AGENCE_BY_ID[agence_id];
          return { _id: agence._id, name: agence.name.toUpperCase() };
        })
      );
    }
  }
});
